export default "__VITE_ASSET__lhLYcgL3__"